<template>
  <el-dialog title="请选择" v-model="visible" width="300px">
    <el-select v-model="selectedValue" placeholder="请选择" style="width: 100%">
      <div v-for="option in props.optionList" :key="option.value">
        <el-option :label="option.label" :value="option.value" />
      </div>
    </el-select>
    <template #footer>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  optionList: Array
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const visible = ref(props.modelValue)
const selectedValue = ref('')

const confirm = () => {
  if (selectedValue.value) {
    emit('confirm', selectedValue.value)
    closeDialog()
  }
}

const closeDialog = () => {
  emit('update:modelValue', false)
}

watch(visible, (val) => {
  emit('update:modelValue', val)
})

watch(() => props.modelValue, (val) => {
  visible.value = val
})
</script>